import {KeyboardAvoidingView, Platform, View} from "react-native";

/* Adds KeyboardAvoidingView for ios -- for android we don't need it, keyboard works fine */
export const KeyboardAvoidingViewWrapper = (props) => {
    return Platform.OS === 'ios' ? (
        <KeyboardAvoidingView behavior={"padding"} style={[props.style, {flex: 1}]}>
            {props.children}
        </KeyboardAvoidingView>
    ) : <View style={props.style}>{props.children}</View>
}
